// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2lN_K","label":"SetPasswdForm_label__nIfT2"};